<template>
  <div>
    <v-container fluid>
      <div style="float: left">
        <v-dialog v-model="showSearch" width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" depressed v-on="on">Search</v-btn>
          </template>
          <v-card>
            <div style="float: right">
              <v-btn @click="showSearch = false" icon>
                <span class="material-icons">close</span>
              </v-btn>
            </div>
            <v-card-text>
              <div class="form-control">
                <v-layout row wrap>
                  <v-flex xs12>
                    <label>Type</label>
                    <input v-model="filters.type" placeholder="ประเภท" type="text" />
                  </v-flex>
                  <v-flex xs6 pr-1>
                    <div class="form-control">
                      <label>เบอร์โทรศัพท์</label>
                      <input placeholder="Phone no" type="text" v-model="filters.phoneno" />
                    </div>
                  </v-flex>
                  <v-flex xs6 pr-1>
                    <div class="form-control">
                      <label>Supplier</label>
                      <input placeholder="Supplier" type="text" v-model="filters.supplier" />
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu
                      ref="showStartDate"
                      v-model="showEditStartDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-layout>
                          <v-flex>
                            <div class="form-control">
                              <label>วันเวลาที่ต้องการเช่า(เริ่ม)</label>
                              <input
                                placeholder="dd/mm/yyyy"
                                type="text"
                                name
                                v-model="filters.datefrom"
                                v-on="on"
                                readonly
                              />
                            </div>
                          </v-flex>
                          <v-flex>
                            <v-btn fab flat small class="my-0" @click="filters.datefrom = null">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="filters.datefrom"
                        @input="showEditStartDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu
                      ref="showStartDate"
                      v-model="showEditEndDate"
                      :close-on-content-click="false"
                      full-width
                      max-width="290px"
                      color="primary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-layout>
                          <v-flex>
                            <div class="form-control">
                              <label>วันเวลาที่ต้องการเช่า(สิ้นสุด)</label>
                              <input
                                placeholder="dd/mm/yyyy"
                                type="text"
                                name
                                v-model="filters.dateto"
                                v-on="on"
                                readonly
                              />
                            </div>
                          </v-flex>
                          <v-flex>
                            <v-btn fab flat small class="my-0" @click="filters.dateto = null">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </template>
                      <v-date-picker
                        color="primary"
                        v-model="filters.dateto"
                        @input="showEditEndDate = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                </v-layout>
                <div>
                  <v-btn depressed color="primary" @click="onSearch" block>Search</v-btn>
                </div>
                <div>
                  <v-btn color="primary" @click="clearSearch" block outline>Clear search</v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
      <v-pagination
        @input="changepage"
        v-model="page"
        :length="pagelength"
        :total-visible="7"
      ></v-pagination>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="desserts"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">
            <v-avatar size="30">
              <img
                v-if="props.item.profile_pic"
                :src="props.item.profile_pic"
                width="30"
                height="30"
                :alt="props.item.first_name"
              />
              <img
                v-else
                :src="'/static/img/assets/livechat/profile.png'"
                width="30"
                height="30"
                :alt="props.item.first_name"
              />
            </v-avatar>
          </td>
          <td class="text-xs-center">{{ props.item.company }}</td>
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">{{ props.item.type }}</td>
          <td class="text-xs-center">{{ props.item.address ? props.item.address : '-' }}</td>
          <td class="text-xs-center">{{ props.item.status ? props.item.status : '-' }}</td>
          <td class="text-xs-center">
            {{ props.item.group_remark ? props.item.group_remark : '-' }}
          </td>
          <td class="text-xs-center">{{ props.item.partofday ? props.item.partofday : '-' }}</td>
          <td class="text-xs-center" style="white-space: nowrap">
            {{ props.item.start_date | dateFormat('DD/MM/YYYY') }} ~
            {{ props.item.end_date | dateFormat('DD/MM/YYYY') }}
          </td>
          <!-- <td class="text-xs-center">{{ props.item.quantity }}</td> -->
          <td class="text-xs-center">{{ props.item.phoneno }}</td>
          <td class="text-xs-center">
            <a
              v-if="/(\.pdf$)/.test(props.item.credentials)"
              rel="noopener noreferrer"
              target="_blank"
              :href="props.item.credentials"
            >
              <span class="material-icons">picture_as_pdf</span>
            </a>
            <div v-else-if="props.item.credentials" class="pa-3">
              <a rel="noopener noreferrer" target="_blank" :href="props.item.credentials">
                <div
                  style="height: 160px; border-radius: 5px"
                  class="grey lighten-4 text-xs-center"
                >
                  <img
                    v-if="props.item.credentials"
                    style="height: 100%; max-height: 160px"
                    :src="props.item.credentials"
                    alt
                  />
                  <img
                    v-else
                    style="height: 100%; max-height: 160px"
                    src="/static/img/empty-img-placeholder.png"
                    alt
                  />
                </div>
              </a>
            </div>
            <div v-else>-</div>
          </td>
          <td class="text-xs-center">
            <a
              v-if="/(\.pdf$)/.test(props.item.bookbank)"
              rel="noopener noreferrer"
              target="_blank"
              :href="props.item.bookbank"
            >
              <span class="material-icons">picture_as_pdf</span>
            </a>
            <div v-else-if="props.item.bookbank" class="pa-3">
              <a rel="noopener noreferrer" target="_blank" :href="props.item.bookbank">
                <div
                  style="height: 160px; border-radius: 5px"
                  class="grey lighten-4 text-xs-center"
                >
                  <img
                    v-if="props.item.bookbank"
                    style="height: 100%; max-height: 160px"
                    :src="props.item.bookbank"
                    alt
                  />
                  <img
                    v-else
                    style="height: 100%; max-height: 160px"
                    src="/static/img/empty-img-placeholder.png"
                    alt
                  />
                </div>
              </a>
            </div>
            <div v-else>-</div>
          </td>
          <td class="text-xs-center">
            <a
              v-if="/(\.pdf$)/.test(props.item.quotation)"
              rel="noopener noreferrer"
              target="_blank"
              :href="props.item.quotation"
            >
              <span class="material-icons">picture_as_pdf</span>
            </a>
            <div v-else-if="props.item.quotation" class="pa-3">
              <a rel="noopener noreferrer" target="_blank" :href="props.item.quotation">
                <div
                  style="height: 160px; border-radius: 5px"
                  class="grey lighten-4 text-xs-center"
                >
                  <img
                    v-if="props.item.quotation"
                    style="height: 100%; max-height: 160px"
                    :src="props.item.quotation"
                    alt
                  />
                  <img
                    v-else
                    style="height: 100%; max-height: 160px"
                    src="/static/img/empty-img-placeholder.png"
                    alt
                  />
                </div>
              </a>
            </div>
            <div v-else>-</div>
          </td>
          <td class="text-xs-center">{{ props.item.note }}</td>
          <td @click="showedit(props.item)" class="text-xs-right">
            <span
              :style="`color: ${$vuetify.theme.primary}; cursor: pointer;font-size: 15px`"
              class="material-icons"
              >create</span
            >
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" width="600px">
        <v-card v-if="dialog">
          <v-card-text>
            <v-layout row wrap>
              <!-- <v-flex xs12>
                <div :class="{'has-error': errors.has('credentials')}">
                  <label>อัพโหลดใบวางบิล/ ใบเสนอราคา</label>
                  <uploadfile v-validate="'required'" :height="80" v-model="input.credentials"></uploadfile>
                  <span
                    class="text-error"
                    v-if="errors.has('credentials')"
                  >{{ errors.first('credentials') }}</span>
                </div>
              </v-flex>
              <v-flex xs12>
                <div :class="{'has-error': errors.has('bookbank')}">
                  <label>หน้าสมุดบัญชีธนาคาร</label>
                  <uploadfile v-validate="'required'" :height="80" v-model="input.bookbank"></uploadfile>
                  <span
                    class="text-error"
                    v-if="errors.has('bookbank')"
                  >{{ errors.first('bookbank') }}</span>
                </div>
              </v-flex>
              <v-flex xs12>
                <div :class="{'has-error': errors.has('quotation')}">
                  <label>ใบเสนอราคา</label>
                  <uploadfile v-validate="'required'" :height="80" v-model="input.quotation"></uploadfile>
                  <span
                    class="text-error"
                    v-if="errors.has('quotation')"
                  >{{ errors.first('quotation') }}</span>
                </div>
              </v-flex>-->
              <v-flex xs12 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('name') }">
                  <label>ชื่อ</label>
                  <input v-model="input.name" name="name" type="text" />
                  <span class="text-error" v-if="errors.has('name')">{{
                    errors.first('name')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('status') }">
                  <label>สถานะ</label>
                  <multiselect
                    v-model="input.status"
                    :options="['Approve', 'Reject']"
                    selectLabel
                    :placeholder="'Select Status'"
                    selectedLabel
                    :searchable="false"
                    deselect-label
                    open-direction="bottom"
                  ></multiselect>
                  <!-- <input v-model="input.name" name="name" type="text" /> -->
                  <span class="text-error" v-if="errors.has('status')">{{
                    errors.first('nstatusame')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('group_remark') }">
                  <label>Group Remark</label>
                  <input v-model="input.group_remark" name="group_remark" type="text" />
                  <span class="text-error" v-if="errors.has('group_remark')">{{
                    errors.first('group_remark')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('type') }">
                  <label>ประเภทรถ</label>
                  <input v-model="input.type" name="type" type="text" />
                  <span class="text-error" v-if="errors.has('type')">{{
                    errors.first('type')
                  }}</span>
                </div>
              </v-flex>
              <!-- <v-flex xs6 pa-1>
                <div class="form-control" :class="{'has-error': errors.has('type')}">
                  <label>จำนวน</label>
                  <input v-model="input.quantity" name="quantity" type="number" />
                  <span
                    class="text-error"
                    v-if="errors.has('quantity')"
                  >{{ errors.first('quantity') }}</span>
                </div>
              </v-flex>-->
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('company') }">
                  <label>บริษัท</label>
                  <input v-model="input.company" name="company" type="text" />
                  <span class="text-error" v-if="errors.has('company')">{{
                    errors.first('company')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('phoneno') }">
                  <label>เบอร์โทรศัพท์</label>
                  <input v-model="input.phoneno" name="phoneno" type="text" />
                  <span class="text-error" v-if="errors.has('phoneno')">{{
                    errors.first('phoneno')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <div class="form-control" :class="{ 'has-error': errors.has('address') }">
                  <label>สถานที่</label>
                  <input v-model="input.address" name="address" type="text" />
                  <span class="text-error" v-if="errors.has('address')">{{
                    errors.first('address')
                  }}</span>
                </div>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  ref="showStartDate"
                  v-model="showStartDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <v-layout>
                      <v-flex>
                        <div class="form-control">
                          <label>วันเวลาที่ต้องการเช่า(เริ่ม)</label>
                          <input
                            placeholder="dd/mm/yyyy"
                            type="text"
                            name
                            v-model="filteredStartDate"
                            v-on="on"
                            readonly
                          />
                        </div>
                      </v-flex>
                      <v-flex>
                        <v-btn fab flat small class="my-0" @click="input.start_date = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="input.start_date"
                    @input="showStartDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1>
                <v-menu
                  ref="showEndDate"
                  v-model="showEndDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <v-layout>
                      <v-flex class="form-control">
                        <label>วันเวลาที่ต้องการเช่า(สิ้นสุด)</label>
                        <input
                          placeholder="dd/mm/yyyy"
                          type="text"
                          name
                          v-model="filteredEndDate"
                          v-on="on"
                          readonly
                        />
                      </v-flex>
                      <v-flex>
                        <v-btn fab flat small class="my-0" @click="input.end_date = null">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="input.end_date"
                    @input="showEndDate = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12>
                <div class="form-control" :class="{ 'has-error': errors.has('note') }">
                  <label>Note</label>
                  <input v-model="input.note" name="note" type="text" />
                  <span class="text-error" v-if="errors.has('note')">{{
                    errors.first('note')
                  }}</span>
                </div>
              </v-flex>
            </v-layout>
            <div class="text-xs-center">
              <v-btn @click="canceledit" color="grey" outline>CANCEL</v-btn>
              <v-btn :loading="saveloading" @click="saveedit" color="primary" depressed>SAVE</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import uploadfile from '@/components/elements/uploadfile'
import api from '@/api'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  components: {
    Multiselect,
    uploadfile
  },
  data() {
    return {
      limit: 10,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 0,
      showStartDate: false,
      showEditStartDate: false,
      showEditEndDate: false,
      loading: false,
      showSearch: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      showEndDate: false,
      saveloading: false,
      dialog: false,
      input: {},
      filters: {
        type: '',
        datefrom: '',
        dateto: '',
        phoneno: '',
        supplier: ''
      },
      headers: [
        { text: '', value: '', align: 'center' },
        { text: 'บริษัท', value: 'company', align: 'center' },
        { text: 'ชื่อ', value: 'name', align: 'center' },
        { text: 'ประเภทรถ', value: 'type', align: 'center' },
        { text: 'สถานที่', value: 'address', align: 'center' },
        { text: 'สถานะ', value: 'status', align: 'center' },
        { text: 'Group Remark', value: 'group_remark', align: 'center' },
        { text: 'ช่วงเวลา', value: 'partoftime', align: 'center' },
        { text: 'วันที่ต้องการเช่า', value: 'start_date', align: 'center' },
        // { text: 'จำนวน', value: 'quantity', align: 'center' },
        { text: 'ข้อมูลติดต่อ', value: 'phoneno', align: 'center' },
        { text: 'หนังสือรับรอง/สำเนาบัตรประชาชน', value: 'credentials', align: 'center' },
        { text: 'หน้าสมุดบัญชีธนาคาร', value: 'bookbank', align: 'center' },
        { text: 'ใบเสนอราคา', value: 'quotation', align: 'center' },
        { text: 'Note', value: 'note', align: 'center' },
        { text: '', value: '', align: 'center' }
      ],

      desserts: []
    }
  },
  mounted() {
    this.getscgallrentsuppliers()
  },
  computed: {
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot']),
    filteredStartDate() {
      if (this.input.start_date) {
        return moment(this.input.start_date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    filteredEndDate() {
      if (this.input.end_date) {
        return moment(this.input.end_date).format('DD/MM/YYYY')
      } else {
        return ''
      }
    }
  },
  methods: {
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getscgallrentsuppliers(this.limit, this.offset)
      }
    },
    clearSearch() {
      this.filters = {
        type: '',
        datefrom: '',
        dateto: '',
        phoneno: '',
        supplier: ''
      }
      this.getscgallrentsuppliers()
      this.showSearch = false
    },
    onSearch() {
      this.getscgallrentsuppliers()
      this.showSearch = false
    },
    canceledit() {
      this.input = {}
      this.dialog = false
    },
    saveedit() {
      var data = {
        ...this.input
      }
      this.saveloading = true
      api.putscgallrentsuppliersById(data, (err, response) => {
        this.saveloading = false
        var index = this.desserts.findIndex((el) => el.id == this.input.id)
        this.$set(this.desserts, index, this.input)
        this.canceledit()
      })
    },
    showedit(item) {
      this.dialog = true

      this.input = {
        ...item,
        start_date: moment(this.input.start_date).format('YYYY-MM-DD'),
        end_date: moment(this.input.end_date).format('YYYY-MM-DD')
      }
    },
    getscgallrentsuppliers(limit, offset) {
      var vm = this
      var data = {
        limit,
        offset,
        pageid: this.selectedBot.pageid
      }
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      this.loading = true
      if (this.filters.type) {
        data.type = this.filters.type
      }
      if (this.filters.datefrom) {
        data.datefrom = this.filters.datefrom
      }
      if (this.filters.dateto) {
        data.dateto = this.filters.dateto
      }
      if (this.filters.supplier) {
        data.supplier = this.filters.supplier
      }
      if (this.filters.phoneno) {
        data.phoneno = this.filters.phoneno
      }
      api.getscgallrentsuppliers(data, (err, response) => {
        this.loading = false
        if (response.responsecode == 200) {
          if (response.data) {
            this.desserts = response.data
            this.pagetotal = parseInt(vm.desserts[0].total)
          } else {
            this.desserts = []
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/scgallrent/supplierCRM.vue